import isEmpty from 'lodash.isempty';

import { CELL_HEIGHT } from '../constants/ui';

import { toInt } from './primitives';

export const calcX = (cols = [], idx = 0) =>
  cols.reduce((acc, curr, i) => {
    if (i < idx) {
      return acc + curr;
    }

    return acc;
  }, 0);

export const calcY = (idx = 0, height = CELL_HEIGHT) => idx * height;

export const parseLayouts = (layouts = '') => {
  if (isEmpty(layouts)) {
    return [];
  }

  const rows = layouts.split('|');

  const res = rows.map((row, idxRow) => {
    const cols = row.split('x').map((v) => toInt(v));

    return cols.map((col, idxCol) => {
      const x = calcX(cols, idxCol);
      const y = calcY(idxRow);

      return {
        x,
        y,
        w: col,
        h: CELL_HEIGHT,
      };
    });
  });

  return res.reduce((acc, curr) => acc.concat(curr), []);
};

export const parsePreset = (items = [], layouts = {}) => (key) => {
  if (key === 'items') {
    const res = items.map((item) => ({ ...item, i: `${item.asset}.${item.code}` }));

    return res;
  }

  if (key === 'layouts') {
    const entries = Object.entries(layouts);

    const res = entries
      .map(([k, v]) => {
        const vals = parseLayouts(v).map((l, idx) => ({ ...l, i: `${items[idx].asset}.${items[idx].code}` }));

        return { key: k, vals };
      })
      .reduce((acc, curr) => {
        acc[curr.key] = curr.vals;

        return acc;
      }, {});

    return res;
  }
};
